import React from 'react';
import { Link } from 'react-router-dom';

const stats = [
  { value: 'Free', label: 'To get started' },
  { value: '2', label: 'Livestock types' },
  { value: '8', label: 'Data entry forms' },
  { value: 'Rs500', label: 'Pro plan / month' },
];

const Hero: React.FC = () => {
  return (
    <header className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-900 text-white">
      {/* Nav */}
      <nav className="relative z-10 flex items-center justify-between px-4 py-5 max-w-6xl mx-auto sm:px-6 lg:px-8">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-amber-500 flex items-center justify-center">
            <svg className="w-5 h-5 text-slate-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
            </svg>
          </div>
          <span className="text-xl font-bold tracking-tight">FarmLog</span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="#pricing"
            className="hidden sm:inline-flex rounded-lg bg-white/10 px-4 py-2 text-sm font-medium hover:bg-white/20 transition"
          >
            Pricing
          </a>
          <Link
            to="/auth"
            className="rounded-lg bg-amber-500 px-5 py-2 text-sm font-semibold text-slate-900 hover:bg-amber-400 transition"
          >
            Login
          </Link>
        </div>
      </nav>

      {/* Hero content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 pt-12 pb-20 sm:px-6 lg:px-8 sm:pt-20 sm:pb-28">
        <div className="max-w-3xl">
          <p className="inline-block rounded-full bg-amber-500/20 px-4 py-1 text-sm font-medium text-amber-300 mb-6">
            Free forever — no credit card needed
          </p>
          <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl leading-tight">
            Stop losing money.<br />
            <span className="text-amber-400">Start tracking your farm.</span>
          </h1>
          <p className="mt-5 text-lg text-slate-300 sm:text-xl max-w-2xl leading-relaxed">
            FarmLog replaces your paper khatabook with a simple, mobile-friendly web app.
            Track feed, medicine, sales, and expenses for fish ponds and goat herds — know your exact profit per cycle.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/demo"
              className="inline-flex items-center gap-2 rounded-xl bg-amber-500 px-7 py-3.5 text-base font-bold text-slate-900 hover:bg-amber-400 transition shadow-lg shadow-amber-500/25"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
              See Demo
            </Link>
            <a
              href="#pricing"
              className="inline-flex items-center rounded-xl border-2 border-white/30 px-7 py-3.5 text-base font-semibold hover:bg-white/10 transition"
            >
              See pricing
            </a>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="relative z-10 border-t border-white/10 bg-black/30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-4 divide-x divide-white/10">
            {stats.map((stat, i) => (
              <div key={i} className="py-5 px-4 text-center">
                <p className="text-2xl font-bold text-amber-400">{stat.value}</p>
                <p className="mt-1 text-sm text-slate-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
